import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import { APIgetCollectionLikes } from '../api/Collections';
import { APIgetFileLikes } from '../api/Files';
import {
  APIgetShareCollectionLikes,
  APIgetShareFileLikes,
} from '../api/Shares';

import LikesUser from './LikesUser';

import ErrorBoundary from './ErrorBoundary';
import Loading from './Loading';

class LikesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      likes: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.loadLikes();
  }

  getItem() {
    const {
      collection,
      file,
    } = this.props;

    return collection || file;
  }

  getMode() {
    const { collection } = this.props;

    return collection ? 'collection' : 'file';
  }

  loadLikes() {
    const { shareUuid } = this.props;
    this.setState({ loading: true });
    const item = this.getItem();

    if (this.getMode() === 'collection') {
      if (shareUuid) {
        APIgetShareCollectionLikes(shareUuid, item.uuid).then((response) => {
          const { data } = response;
          if (data) {
            this.setState({ likes: data });
          }
          this.setState({ loading: false });
        });
      } else {
        APIgetCollectionLikes(item.uuid).then((response) => {
          const { data } = response;
          if (data) {
            this.setState({ likes: data });
          }
          this.setState({ loading: false });
        });
      }
    } else if (shareUuid) {
      APIgetShareFileLikes(shareUuid, item.uuid).then((response) => {
        const { data } = response;
        if (data) {
          this.setState({ likes: data });
        }
        this.setState({ loading: false });
      });
    } else {
      APIgetFileLikes(item.uuid).then((response) => {
        const { data } = response;
        if (data) {
          this.setState({ likes: data });
        }
        this.setState({ loading: false });
      });
    }
  }

  render() {
    const { handleClose } = this.props;
    const {
      likes,
      loading,
    } = this.state;
    const item = this.getItem();

    return (
      <ErrorBoundary>
        <ModalHeader toggle={handleClose} className="modal-header-center">
          {`${item.likes_count} user${item.likes_count === 1 ? '' : 's'} favorited`}
        </ModalHeader>
        <ModalBody>
          <div className="likes-body">
            {loading ? (
              <Loading />
            ) : (
              <div className="users-list">
                {likes.map(l => (
                  <LikesUser
                    key={l.id}
                    user={l}
                  />
                ))}
              </div>
            )}
          </div>
        </ModalBody>
      </ErrorBoundary>
    );
  }
}

LikesModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  collection: PropTypes.object,
  file: PropTypes.object,
  shareUuid: PropTypes.string,
};

LikesModal.defaultProps = {
  collection: null,
  file: null,
  shareUuid: null,
};

export default LikesModal;
